import React from 'react';
import './PortfolioPage.scss';

interface PortfolioPageProps {
  menuOpen: boolean;
}

const PortfolioPage: React.FC<PortfolioPageProps> = ({ menuOpen }) => {
  return (
    <div className={`portfolio-page ${menuOpen ? 'menu-open' : ''}`}>
      <div className="portfolio-page__hero">
        <div className="portfolio-page__content">
          <h1 className="portfolio-page__title">TESTIMONIALS</h1>
          <div className="portfolio-page__intro">
            <p>
              Explore our collection of wedding films and see how we capture the unique story of each couple.
              From intimate ceremonies to grand celebrations, we approach each wedding with creativity and care.
            </p>
          </div>
          
          <div className="portfolio-page__filter">
            <button className="filter-btn active">All</button>
            <button className="filter-btn">Highlight Films</button>
            <button className="filter-btn">Feature Films</button>
            <button className="filter-btn">Destination Weddings</button>
          </div>
          
          <div className="portfolio-page__gallery">
            {/* Portfolio items */}
            <div className="portfolio-item">
              <div className="portfolio-item__thumbnail">
                <img src="https://images.unsplash.com/photo-1583939003579-730e3918a45a?q=80&w=500&auto=format&fit=crop" alt="Emma & James - Countryside Wedding" />
              </div>
              <div className="portfolio-item__info">
                <h3>Emma & James</h3>
                <p>Countryside Wedding, Summer 2024</p>
              </div>
            </div>
            
            <div className="portfolio-item">
              <div className="portfolio-item__thumbnail">
                <img src="https://images.unsplash.com/photo-1546032996-6dfacbacbf3f?q=80&w=500&auto=format&fit=crop" alt="Sarah & Michael - Beach Wedding" />
              </div>
              <div className="portfolio-item__info">
                <h3>Sarah & Michael</h3>
                <p>Beach Wedding, Spring 2024</p>
              </div>
            </div>
            
            <div className="portfolio-item">
              <div className="portfolio-item__thumbnail">
                <img src="https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=500&auto=format&fit=crop" alt="Jessica & Tom - City Wedding" />
              </div>
              <div className="portfolio-item__info">
                <h3>Jessica & Tom</h3>
                <p>City Wedding, Winter 2023</p>
              </div>
            </div>
            
            <div className="portfolio-item">
              <div className="portfolio-item__thumbnail">
                <img src="https://images.unsplash.com/photo-1511285560929-80b456fea0bc?q=80&w=500&auto=format&fit=crop" alt="Laura & David - Garden Wedding" />
              </div>
              <div className="portfolio-item__info">
                <h3>Laura & David</h3>
                <p>Garden Wedding, Autumn 2023</p>
              </div>
            </div>
            
            <div className="portfolio-item">
              <div className="portfolio-item__thumbnail">
                <img src="https://images.unsplash.com/photo-1551854838-212c50b4c184?q=80&w=500&auto=format&fit=crop" alt="Rachel & John - Destination Wedding" />
              </div>
              <div className="portfolio-item__info">
                <h3>Rachel & John</h3>
                <p>Destination Wedding, Italy 2023</p>
              </div>
            </div>
            
            <div className="portfolio-item">
              <div className="portfolio-item__thumbnail">
                <img src="https://images.unsplash.com/photo-1606800052052-a08af7148866?q=80&w=500&auto=format&fit=crop" alt="Olivia & William - Barn Wedding" />
              </div>
              <div className="portfolio-item__info">
                <h3>Olivia & William</h3>
                <p>Barn Wedding, Summer 2023</p>
              </div>
            </div>
          </div>
          
          <div className="portfolio-page__testimonials">
            <h2>What Our Couples Say</h2>
            <div className="testimonials-grid">
              <div className="testimonial-card">
                <p className="testimonial-text">
                  "Stage Door Weddings captured our day perfectly. The film brings back all the emotions and 
                  memories every time we watch it. It's something we'll treasure forever."
                </p>
                <p className="testimonial-author">- Emma & James</p>
              </div>
              
              <div className="testimonial-card">
                <p className="testimonial-text">
                  "We were blown away by the quality of our wedding film. The team was professional and 
                  unobtrusive on the day, and the final result exceeded our expectations."
                </p>
                <p className="testimonial-author">- Sarah & Michael</p>
              </div>
              
              <div className="testimonial-card">
                <p className="testimonial-text">
                  "Working with Stage Door Weddings was one of the best decisions we made for our wedding. 
                  They truly understood our vision and created a film that perfectly tells our story."
                </p>
                <p className="testimonial-author">- Jessica & Tom</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioPage;
